import { ContentSwitcherValue } from '../../types';

import { getRelatedParams } from './getRelatedParams';

export const getDefaultItems = (
  values: ContentSwitcherValue[],
): Record<string, string> => {
  const defaultItems: Record<string, string> = values.reduce(
    (arr: Record<string, string>, { param: valueParam }, i) => {
      if (i === 0) {
        if (values[i]?.items[0]) {
          // use the first item as default if no paramValue was found
          return { ...arr, [valueParam]: values[i].items[0].id };
        }
        return arr;
      }

      // get all related params
      const relatedParams = Object.entries(arr).reduce<ContentSwitcherValue[]>(
        (agg, [key, value]) => {
          const related = getRelatedParams(
            agg.length ? agg : values,
            key,
            value,
          );

          return related;
        },
        [],
      );

      const value = relatedParams.find(({ param }) => param === valueParam);

      const possibleItems = value?.items;

      // get first option from related params
      if (possibleItems?.length) {
        return { ...arr, [valueParam]: possibleItems[0].id };
      }
      // use the first item as default
      if (values[i].items[0]) {
        return { ...arr, [valueParam]: values[i].items[0].id };
      }

      return arr;
    },
    {},
  );

  return defaultItems;
};
